import React from "react";
import { Box, Link, Icon, IconButton, Divider, Card, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import LinkIcon from '@mui/icons-material/Link';

// component
import ImgLogoIgent from "@imgs/logo-igent.png";
import ImgLogoHengxun from "@imgs/logo-hengxun.png";
import ImgLogoOpenquant from "@imgs/logo-openquant.png";
import { dic } from "@common/text_defs";

const PartnerSection = () => {

  return (
    <Box component="section" className="section bg-light-gray" id="partner">
      <Box component="div" className="container">
        <div className="section__header">
          <h2>{dic.partner.main_title}</h2>
        </div>
        <Grid container spacing={3}>
          <Grid lg={4} md={4} sm={12} xs={12} key={dic.partner.igent.name}>
            <Card className="py-8 px-6 card">
              <a href={dic.partner.igent.website} target="_blank" rel="noreferrer" >
                <Box component="img" src={ImgLogoIgent} sx={{ display: 'inline-block', height: 32, }} />
                <Box component="h4" sx={{ display: 'inline-block' }}>{dic.partner.igent.name}</Box>
              </a>
              <p>{dic.partner.igent.desc}</p>
              <Grid container spacing={2} alignItems="center">
                <Grid >
                  <Link href={dic.partner.igent.website} target="_blank" rel="noreferrer" sx={{ verticalAlign: "middle" }} >
                    <LinkIcon sx={{ display: "inline-block", mr: 2, mt: "4px" }} />
                    <Box sx={{ display: "inline-block", verticalAlign: "top", }}>{dic.partner.igent.website}</Box>
                  </Link>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid lg={4} md={4} sm={12} xs={12} key={dic.partner.openquant.name}>
            <Card className="py-8 px-6 card">
              <a href={dic.partner.openquant.website} target="_blank" rel="noreferrer" >
                <Box component="img" src={ImgLogoOpenquant} sx={{ display: 'inline-block', height: 26, mr: 1 }} />
                <Box component="h4" sx={{ display: 'inline-block' }}>{dic.partner.openquant.name}</Box>
              </a>
              <p>{dic.partner.openquant.desc}</p>
              <div className="h-auto" />
              <Grid >
                <Link href={"https://www.open-quant.com"} target="_blank" rel="noreferrer" sx={{ verticalAlign: "middle" }} >
                  <LinkIcon sx={{ mr: 2, mt: "4px" }} />
                  <Box sx={{ display: "inline-block", verticalAlign: "top" }}>{dic.partner.openquant.website}</Box>
                </Link>
              </Grid>
            </Card>
          </Grid>
          <Grid lg={4} md={4} sm={12} xs={12} key={dic.partner.hengxun.name}>
            <Card className="py-8 px-6 card">
              <a href={dic.partner.hengxun.website} target="_blank" rel="noreferrer" >
                <Box component="img" src={ImgLogoHengxun} sx={{ display: 'inline-block', height: 26, mr: 1 }} />
                <Box component="h4" sx={{ display: 'inline-block' }}>{dic.partner.hengxun.name}</Box>
              </a>
              <p>{dic.partner.hengxun.desc}</p>
              <div className="h-auto" />
              <Grid >
                <Link href={"http://www.hengxun-tech.com"} target="_blank" rel="noreferrer" sx={{ verticalAlign: "middle" }} >
                  <LinkIcon sx={{ mr: 2, mt: "4px" }} />
                  <Box sx={{ display: "inline-block", verticalAlign: "top" }}>{dic.partner.hengxun.website}</Box>
                </Link>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box >
  );
};

export { PartnerSection };
